<div class="list">
  <label>{{ deselectedLabel }}:</label>
  <ul>
    @for (client of notSelectedClients; track client) {
    <li
      (click)="toggleInLeftSelection(client.id)"
      [class.selected]="leftSelection.has(client.id)"
    >
      {{ client.name }}
    </li>
    }
  </ul>
</div>

@if (!readonly) {
<div class="buttons">
  <btn (click)="selectAll()" [disabled]="disabled" title="Make all available">
    <span>&gt;&gt;</span>
  </btn>
  <btn (click)="select()" [disabled]="disabled" title="Make selected available">
    <span>&gt;</span>
  </btn>
  <btn
    (click)="deselect()"
    [disabled]="disabled"
    title="Make selected not-available"
  >
    <span>&lt;</span>
  </btn>
  <btn
    (click)="deselectAll()"
    [disabled]="disabled"
    title="Make all not-available"
  >
    <span>&lt;&lt;</span>
  </btn>
</div>
} @if (readonly) {
<div class="blank"></div>
}

<div class="list">
  <label>{{ selectedLabel }}:</label>
  <ul>
    @for (client of selectedClients; track client) {
    <li
      (click)="toggleInRightSelection(client.id)"
      [class.selected]="rightSelection.has(client.id)"
    >
      {{ client.name }}
    </li>
    }
  </ul>
</div>
